import Alerts from './GlobalAlerts.vue';
import ConfirmationDialogues from './ConfirmationDialogues.vue';

export default {
  install(Vue) {
    Vue.component('GlobalAlerts', Alerts);
    Vue.component('ConfirmationDialogues', ConfirmationDialogues);
  },
};
